var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_Icons",
    "data-name": "Menu Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1765",
    "data-name": "Rectangle 1765",
    width: 19.565,
    height: 17.933,
    fill: "#5b788f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 25,
    height: 25,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791",
    transform: "translate(2.718 3.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3791-2",
    "data-name": "Group 3791",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6025",
    "data-name": "Path 6025",
    d: "M21.324,11.644c.009-.007.013-.019.021-.027a.777.777,0,0,0,.145-.188.677.677,0,0,0,.054-.078.791.791,0,0,0,0-.665.631.631,0,0,0-.054-.078.8.8,0,0,0-.145-.188c-.007-.009-.011-.021-.021-.028l-4.89-4.076a.815.815,0,1,0-1.044,1.252l3.16,2.635H6.944a.815.815,0,1,0,0,1.63H18.549l-3.16,2.635a.815.815,0,1,0,1.044,1.251Z",
    transform: "translate(-2.052 -2.052)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6026",
    "data-name": "Path 6026",
    d: "M7.337,17.118a.814.814,0,0,0-.815-.815H2.447a.816.816,0,0,1-.816-.816V2.445a.815.815,0,0,1,.816-.815H6.522a.815.815,0,0,0,0-1.63H2.447A2.446,2.446,0,0,0,0,2.445V15.488a2.446,2.446,0,0,0,2.447,2.445H6.522a.814.814,0,0,0,.815-.815",
    transform: "translate(0 0)",
    fill: "#5b788f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.613f32a9ab5db1a718407c4314654868.svg";
export { ForwardRef as ReactComponent };